import { outOfBandThemeColors } from '@/theme/colors';
import { Box, Container, Link, Stack } from '@montugroup/design-system';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { styled, SwipeableDrawer, Toolbar } from '@mui/material';

/* shared/layout */
export const OnboardingHeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: outOfBandThemeColors.uMeds.merino100,
  padding: `${theme.spacing(3.5)} 0`,
  [`${theme.breakpoints.up('lg')},${theme.breakpoints.up('xl')}`]: {
    padding: `${theme.spacing(4.5)} 0`,
  },
}));

export const OnboardingHeaderContainerV2 = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: theme.palette.primary.main,
  padding: `${theme.spacing(3.5)} 0`,
  [`${theme.breakpoints.up('lg')},${theme.breakpoints.up('xl')}`]: {
    padding: `${theme.spacing(4.5)} 0`,
  },
}));

export const OnboardingContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  paddingLeft: theme.spacing(6),
  paddingRight: theme.spacing(6),
  [`${theme.breakpoints.up('sm')},${theme.breakpoints.up('md')}`]: {
    paddingLeft: theme.spacing(16),
    paddingRight: theme.spacing(16),
  },
  [`${theme.breakpoints.up('lg')},${theme.breakpoints.up('xl')}`]: {
    paddingLeft: theme.spacing(34),
    paddingRight: theme.spacing(34),
    maxWidth: theme.spacing(360),
  },
}));

export const ContentContainer = styled(OnboardingContainer)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  paddingTop: theme.spacing(6),
  flex: 1,
}));

export const Background = styled(Box)(() => ({
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  background: outOfBandThemeColors.uMeds.merino,
}));

export const OnboardingFooterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  background: theme.palette.primary.main,
  padding: `${theme.spacing(8)} ${theme.spacing(16)}`,
  [theme.breakpoints.up('md')]: {
    padding: `${theme.spacing(16)} ${theme.spacing(16)}`,
  },
  [theme.breakpoints.up('lg')]: {
    padding: `${theme.spacing(16)} ${theme.spacing(50)}`,
  },
}));

/* Header - Mobile */
export const StyledMenuIconContainer = styled(Box)`
  display: flex;
`;

export const StyledMenuIcon = styled(MenuIcon)(({ theme }) => ({
  height: 35,
  width: 35,
  color: theme.palette.primary.main,
}));

export const StyledNavToolbar = styled(Toolbar)(({ theme }) => ({
  padding: theme.spacing(4),
  justifyContent: 'space-between',
  gap: theme.spacing(8),
  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.spacing(5),
  },
}));

export const StyledMenuDrawer = styled(SwipeableDrawer)(({ theme }) => ({
  '& .MuiPaper-root': {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
  },
}));

export const StyledNavLinkContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(4),
  gap: theme.spacing(4),
}));

export const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
  color: theme.palette.common.white,
}));

/* Footer */
export const StyledStack = styled(Stack)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  gap: theme.spacing(6),
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.common.white,
  textDecoration: 'underline',
  '&:hover': {
    color: theme.palette.common.white,
  },
}));

/* Alerts */
export const AlertContainer = styled(OnboardingContainer)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(8),
    gap: theme.spacing(4),
  },
  [theme.breakpoints.down('md')]: {
    padding: 0,
  },
  '&:empty': {
    display: 'none',
  },
}));

export default null;
